/* eslint-disable prefer-destructuring */
import React, { useState } from 'react'
import { fireClevertapEvent } from 'AccountsUtils'
import { getCookie } from 'AccountsUtils'
import { getMappedValue } from '../utils/arabicUtils'
import BaggageInfo from './BaggageInfo'
import SlideModal from './SlideModal'

const textLinkCreator = (text, internalLink) => {
  let msg = text
  let returnMarkUp = null
  if (text && internalLink && internalLink.length > 0) {
    let returnValue = null
    returnMarkUp = internalLink.map(item1 => {
      const { tag, link, delimiter } = item1
      if (tag && link) {
        const replacer = tag.split(delimiter).join('')
        let textSplit = msg === tag ? [''] : []
        if (tag && msg.includes(tag)) {
          textSplit = msg.split(tag)
          msg = textSplit[1]
        }
        if (textSplit && textSplit.length >= 1) {
          let i = 0
          returnValue = textSplit.reduce((init, innerText) => {
            let newInit = init
            if (!innerText.includes('$$') && i === 0) {
              newInit = newInit.concat([
                innerText,
                ' ',
                <a className="c-blue" rel="noopener noreferrer" href={link} target="_blank">
                  {replacer}
                </a>
              ])
            }
            i += 1
            return newInit
          }, [])
        } else {
          returnValue = [text]
        }
      }
      return returnValue
    })
  }
  return returnMarkUp
}

const subLabelMap = {
  adult: getMappedValue('per adult'),
  infant: getMappedValue('per infant'),
  checkIn: getMappedValue('check-in'),
  cabin: getMappedValue('cabin')
}

const valueSubBlock = (value, subValue, isPWA, grey = false, type) => (
  <React.Fragment>
    <p
      className={`${isPWA ? 'fs-14' : 'fs-caption-2 pl-2 fw-600'} ${
        grey ? 'color-8a' : ''
      }`}
    >
      <BaggageInfo isCab={subValue === getMappedValue('cabin')} info={value} isPWA={isPWA} type={type} />
    </p>
    <p
      className={`${isPWA ? '' : 'fs-caption-2 c-grey-40'} tt-sentence ${
        value === 'baggage' ? 'c-grey-40' : 'mb-1'
      } ${value ? 'fs-13' : 'fs-15 color-8a'} c-grey-40
      ${isPWA ? '' : 'pt-1'}`}
    >
      {subValue}
    </p>
  </React.Fragment>
)

const BaggageItem = ({
  type,
  cabinBg,
  freeText = '',
  defaultText = null,
  toggleViewDetails,
  checkInBaggage,
  isPWA,
  setRowheight,
  tripId
}) => {
  const [expanderFlag, updateExpanderFlag] = useState(false)
  const [slider, setSlider] = useState(false)
  const isRTL = getCookie('selectedLanguage') === 'ar'

  const toggleText = e => {
    fireClevertapEvent('viewed_baggage_details', { trip_id: tripId })
    if (!expanderFlag) {
      updateExpanderFlag(true)
      setRowheight('h-110')
    } else {
      updateExpanderFlag(false)
      setRowheight('h-18')
    }
  }
  return (
    <React.Fragment>
      <div className={`${isPWA ? 'border-bottom-grey flex flex-middle flex-between h-12 px-4' : 'flex'}`}>
        <If condition={isPWA}>
          <div className="min-40 pr-2">
            {valueSubBlock(
              checkInBaggage || cabinBg || defaultText || freeText ? `${getMappedValue('Baggage')}/${type}` : '',
              '',
              isPWA,
              true
            )}
          </div>
        </If>

        <div className={`flex ${isRTL ? 'flex-row-reverse' : ''} ${isPWA ? 'flex-middle' : 'flex-1'}`}>
          <If condition={checkInBaggage}>
            <div className={`${cabinBg ? '' : 'px-2'} ${cabinBg && isPWA ? 'px-4' : ''} ${isPWA ? 'ta-r' : `flex ${isRTL ? 'flex-row' : 'flex-row-reverse'}`}`} style={{ alignItems: 'baseline', minWidth: '88px' }}>
              {valueSubBlock(checkInBaggage, subLabelMap.checkIn, isPWA, false, type)}
            </div>
          </If>
          <If condition={cabinBg}>
            <div className={`${isPWA ? 'pr-4 ta-r' : `px-5 flex ${isRTL ? 'flex-row' : 'flex-row-reverse'}`}`} style={{ alignItems: 'baseline' }}>
              {valueSubBlock(cabinBg, subLabelMap.cabin, isPWA, false, type)}
            </div>
          </If>
          <If condition={freeText && isPWA}>
            <div className="flex">
              <a
                href="#"
                className={`tt-sentence c-blue cursorPoi tt-sentence ${
                  isPWA ? 'fs-15' : 'fs-caption-2'
                }`}
                onClick={e => toggleViewDetails(e, { freeText, type })}
              >
                {getMappedValue('view details')}
              </a>
            </div>
          </If>
          <If condition={!((cabinBg && checkInBaggage) || freeText) && defaultText && !isPWA}>
            {defaultText.text.map(data => (
              <div className="">
                <p className="fs-13 tt-sentence fs-caption-2 c-grey-40">
                  {textLinkCreator(data, defaultText.defaultResources)}
                </p>
              </div>
            ))}
          </If>
          <If condition={!((cabinBg && checkInBaggage) || freeText) && defaultText && isPWA}>
            <div className="fs-3 color-8a pr-4">
              <p>{getMappedValue('info. not available')} </p>
              <p className={`c-blue ${isRTL ? 'ta-left' : 'ta-right'}`} onClick={() => setSlider(true)}>{getMappedValue('learn more')}</p>
            </div>
          </If>
        </div>
      </div>
      <If condition={freeText && !isPWA}>
        <If condition={freeText}>
          <div className="flex flex-1 flex-middle pl-2">
            <div className="flex">
              <p className="fs-12 pb-1 tt-sentence">
                {expanderFlag ? freeText : freeText && freeText.substring(0, 80)}
              </p>
            </div>
            {freeText.length > 80 && (
              <div className="flex flex-1">
                <span
                  className="pl-2 c-blue pointer"
                  onClick={e => {
                    toggleText(e)
                  }}
                >
                  {!expanderFlag && `...${getMappedValue('read more')}`}
                </span>
              </div>
            )}
          </div>
        </If>
      </If>
      <If condition={!((cabinBg && checkInBaggage) || freeText) && defaultText}>
        <SlideModal header={`${getMappedValue('Baggage')}/${getMappedValue('Infant')}`} open={slider} onCloseClick={() => setSlider(false)}>
          {defaultText.text.map(data => (
            <div className="bg-white h-104 p-4">
              <p className="fs-3 tt-sentence">
                {textLinkCreator(data, defaultText.defaultResources)}
              </p>
            </div>
          ))}
        </SlideModal>
      </If>
    </React.Fragment>
  )
}

export default BaggageItem
